/**
 * 资金流水列表页面路径
 */
export const JOURNAL_LIST_ROUTE_PAGE_PATH = '/journal/list'
